<template>
    <div id="app">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" color="#FFFF99">
                    <v-card-title>
                        Condiciones Comerciales
                    </v-card-title>
                    <v-card-text class="pt-2">
                        <v-row dense>
                            <v-col cols="12" sm="6" md="6">
                                <v-select v-model="select" :items="tipos" item-text="nombre" item-value="nombre"
                                    label="Tipo de Condición Comercial" return-object single-line menu-props="auto"
                                    hide-details required dense></v-select>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-text-field dense v-model="revision" label="Revisión"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="3">
                                <v-btn dense tile color="success" @click="cargarListado()">
                                    <v-icon left> mdi-magnify </v-icon>
                                    Buscar
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-data-table :headers="headers" :items="detalle" locale="es-ar" class="elevation-1"
                        :items-per-page="40" :footer-props="{
                            itemsPerPageText: 'Items por página',
                        }">
                        <template v-slot:top>
                            <v-toolbar flat>
                                <v-toolbar-title>Condiciones</v-toolbar-title>
                                <v-divider class="mx-4" inset vertical></v-divider>
                                <v-spacer></v-spacer>
                                <v-dialog v-model="dialog" max-width="850px">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn color="primary" dark class="mb-2" v-bind="attrs" v-on="on">
                                            Agregar Condición
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-title>
                                            <span class="headline">{{ formTitle }}</span>
                                        </v-card-title>

                                        <v-card-text>
                                            <v-container>
                                                <v-row dense>
                                                    <v-col cols="12" sm="3" md="3">
                                                        <v-text-field autofocus v-model="editedItem.item"
                                                            label="Item"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="12" sm="6" md="6">
                                                        <v-text-field v-model="editedItem.titulo"
                                                            label="Título"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row dense>
                                                    <v-col cols="6" sm="3" md="3">
                                                        <v-text-field v-model="editedItem.letra"
                                                            label="Letra"></v-text-field>
                                                    </v-col>
                                                    <v-col cols="6" sm="6" md="6">
                                                        <v-text-field v-model="editedItem.subtitulo"
                                                            label="Subtitulo"></v-text-field>
                                                    </v-col>
                                                </v-row>
                                                <v-row dense>
                                                    <v-col cols="12" sm="12" md="12">
                                                        <v-textarea v-model="editedItem.texto"
                                                            label="Descripción"></v-textarea>
                                                    </v-col>
                                                </v-row>
                                                <v-row dense>
                                                    <v-col cols="6" sm="6" md="6">
                                                        <v-select v-model="editedItem.estado" :items="estado"
                                                            item-text="nombre" item-value="valor" label="Estado">
                                                        </v-select>
                                                    </v-col>
                                                </v-row>
                                            </v-container>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="close">
                                                Cancelar
                                            </v-btn>
                                            <v-btn color="blue darken-1" text @click="save">
                                                Guardar
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-model="dialogDelete" max-width="500px">
                                    <v-card>
                                        <v-card-title class="headline">Está seguro que desea borrar?</v-card-title>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="blue darken-1" text @click="closeDelete">Cancel</v-btn>
                                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">OK</v-btn>
                                            <v-spacer></v-spacer>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-toolbar>
                        </template>
                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-2" color="purple" @click="editItem(item)">
                                mdi-pencil
                            </v-icon>
                            <v-icon small color="red" @click="deleteItem(item)">
                                mdi-delete
                            </v-icon>
                        </template>
                    </v-data-table>
                </v-card>

                <v-card color="blue" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardaritems()">Guardar</v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>
<script>
import moment from "moment";
import axios from "../../axios-auth";
import readXlsFile from "read-excel-file";
export default {
    data: (vm) => ({
        usuario: "",
        valid: false,
        lazy: false,
        select: "",
        estado: [
            { nombre: "Activo", valor: "A" },
            { nombre: "Inactivo", valor: "I" },
        ],
        tipos: [
            { nombre: "Servicio de Posventa" },
            { nombre: "Venta Comercial" },
        ],
        revision: "",
        dialog: false,
        dialogDelete: false,
        headers: [
            { text: "Item", value: "item", sortable: false },
            { text: "Título", value: "titulo", sortable: false },
            { text: "Letra", value: "letra", sortable: false },
            { text: "Subtítulo", value: "subtitulo", sortable: false },
            { text: "Descripción", value: "texto", sortable: false },
            { text: "Estado", value: "estado", sortable: false },
            { text: "Acciones", value: "actions", sortable: false },
        ],
        editedIndex: -1,
        editedItem: {
            item: "",
            titulo: "",
            letra: "",
            subtitulo: "",
            texto: "",
            estado: "",
        },
        defaultItem: {
            item: "",
            titulo: "",
            letra: "",
            subtitulo: "",
            texto: "",
            estado: "",
        },
        detalle: [],
        condiciones: [],
    }),

    watch: {
        dialog(val) {
            val || this.close();
            console.log(this.valid);
        },
        dialogDelete(val) {
            val || this.closeDelete();
        },
    },
    computed: {
        formTitle() {
            return this.editedIndex === -1 ? "Nueva Condición" : "Editar Condición";
        },
        show: {
            get() {
                //this.mostrar = true;
                //this.resptrabajo = this.$store.state.nombre.toString().trim();
                //this.cargarObras();
                // return this.visible;
            },
            set(value) {
                if (!value) {
                    this.vaciarListado();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },
    methods: {

        cargarListado() {
            this.vaciarListado();
            const nombre = this.select.nombre;
            const revision = this.revision;
            let self = this;
            axios
                .get("/Comercial/CargarCondiciones?", {
                    params: {
                        tipo: nombre,
                        revision: revision,
                    },
                })
                .then((response) => {
                    //self.cronograma = response.data;
                    response.data.forEach((element) => {
                        self.detalle.push(element);
                    });
                })
                .catch((error) => {
                    self.detalle = [];
                    console.log(error);
                });
        },

        editItem(item) {
            this.editedIndex = this.detalle.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialog = true;
        },

        deleteItem(item) {
            this.editedIndex = this.detalle.indexOf(item);
            this.editedItem = Object.assign({}, item);
            this.dialogDelete = true;
        },

        deleteItemConfirm() {
            this.detalle.splice(this.editedIndex, 1);
            this.closeDelete();
        },

        close() {
            this.dialog = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        closeDelete() {
            this.dialogDelete = false;
            this.$nextTick(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            });
        },

        save() {
            if (this.editedIndex > -1) {
                Object.assign(this.detalle[this.editedIndex], this.editedItem);
            } else {
                this.detalle.push(this.editedItem);
            }
            this.close();
        },

        vaciarListado() {
            this.detalle = [];
        },

        guardaritems() {
            this.$swal({
                title: "Guardar Condición",
                text: "¿Desea guardar los datos?",
                icon: "success",
                type: "success",
                showCancelButton: true,
                background: "#ececec",
                confirmButtonText: "Si",
                cancelButtonText: "No",
                showCloseButton: true,
                showLoaderOnConfirm: true,
            }).then((result) => {
                if (result.value) {
                    this.detalle.forEach((element) => {
                        if (element.texto != "" && element.texto != null) {
                            //   const fill = (number, len) =>
                            //     "0".repeat(len - number.toString().length) + number.toString();
                            //   this.itemtarea = fill(Number(this.item) + 1, 3);
                            this.condiciones.push({
                                tipo: this.select.nombre,
                                revision: this.revision,
                                item: element.item,
                                titulo: element.titulo,
                                letra: element.letra,
                                subtitulo: element.subtitulo,
                                texto: element.texto,
                                estado: element.estado,
                            });
                        }
                    });
                    //   var detallecomp = {

                    //     detalle: this.items,
                    //   };

                    let self = this;
                    axios
                        .post("/Comercial/Guardarcondiciones", this.condiciones)
                        .then((response) => {
                            self.$refs.form.resetValidation();
                            self.vaciarListado();
                            self.showAlert({
                                icon: "success",
                                title: "Condiciones guardadas con éxito",
                                vm: self,
                            });
                            self.$emit("close");
                        })
                        .catch({});
                } else {
                }
            });
        },
        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 3000,
            });
        },
    },
};
</script>
